import { cn } from "@/lib/utils";
import { CalendarClock } from "lucide-react";
import { recencyLine, daysOld } from "./labels";

// "as of 12 Jun 2026 · 13 days old" — keyed to the CONTENT date (occurred_at), not the
// pull date. Goes amber once a cited item is genuinely old.
export function RecencyBadge({
  date,
  staleAfterDays = 90,
  className,
  withIcon = true,
}: {
  date: string | null | undefined;
  staleAfterDays?: number;
  className?: string;
  withIcon?: boolean;
}) {
  const days = daysOld(date);
  const stale = days != null && days > staleAfterDays;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 font-body text-[11px] leading-none",
        stale ? "text-[hsl(var(--financial-gold))]" : "text-muted-foreground",
        className,
      )}
    >
      {withIcon && <CalendarClock className="h-3 w-3 shrink-0" aria-hidden />}
      {recencyLine(date)}
    </span>
  );
}
